define(
    'viewmodels/secured/help/guided/importDocuments',[
        "viewmodels/ViewModel",
        "plugins/router",
        "helper/textParser",
        "services/session",
        "i19n!i19n/strings",
    ],
    function (ViewModel, router, textParser, session, i19n) {

        var vm = new ViewModel({
            i19n: i19n,
            id: '4',
            descriptions: ko.observableArray([]),
            todos: ko.observableArray([]),
            tip: ko.observable('')
        });

        vm.activate = function () {
            //text | href | target

            if (vm.descriptions().length == 0) {
                vm.descriptions.push("The fileplan Importer makes it easy to import documents into a fileplan Library from Windows folders on your computer or a network drive. ");
                vm.descriptions.push("The importer is included with the fileplan Windows client and can be found on the Windows Start Menu after the client has been installed. ");
                vm.descriptions.push("The fileplan Importer can also populate List values when you have folders that equate to a list, for example client, project or matter folders. ");
            }
            if (vm.todos().length == 0) {
                vm.todos.push({ icon: 'fa-video-camera', isDone: false, html: textParser.toHtml('Watch the {Importing documents to fileplan | http://www.fileplan.com/importing-documents-video | _blank} video.') });
                vm.todos.push({ icon: 'fa-book', isDone: false, html: textParser.toHtml('Read the {How to import documents | http://help.fileplan.com/hc/en-us/articles/208632606 | _blank} article.') });
                vm.todos.push({ icon: 'fa-book', isDone: false, html: textParser.toHtml('Read the {How to use fileplan Importer to populate list values | http://help.fileplan.com/hc/en-us/articles/115003094746 | _blank} article.') });
                vm.todos.push({ icon: 'fa-hand-pointer-o', isDone: false, html: textParser.toHtml('Use {fileplan Importer | fpimporter:// | _blank} to import existing documents. ') });
            }
            vm.tip(textParser.toHtml(" "));
        };
        vm.attached = function () {
            $(".a-route").unbind("click");
            $(".a-route").bind("click", function (e) {
                router.navigate($(this).attr("href"));

                return false;
            });
        };

        return vm;
    }
);
